import audio from '../audio/awake.mp3'

const Audioplayer = (props) => {
    return (
        <div className='audio-player flex'>
            <audio autoPlay controls  src={props.src} onTimeUpdate={e=>{
               var tag= e.target
               if(tag.ended===true){
                   props.onEnd(tag)
                   console.log('end')
               }
            }} />
        </div>
    )
}

export default Audioplayer
